import Cookies from 'js-cookie'

import { Consent } from '../../api/AccountConsent/getAccountConsents'
import {
  consentCookieIsExpired,
  getConsentCookie,
  isToBeRequested,
} from '../../apps/Popups/components/ConsentProvider/pure'

export const hasUnexpiredConsentCookie = (accountId: string): boolean =>
  Boolean(Cookies.get(`accountConsent_shouldNotCallApi_forAccount_${accountId}`))
export const setUnexpiredConsentCookie = (accountId: string): void => {
  Cookies.set(`accountConsent_shouldNotCallApi_forAccount_${accountId}`, 'on', { expires: 1 / 24 })
}

export const shouldPreventApiThrottling = (consent: Consent, accountId: string): boolean => {
  const thereIsNoConsentThatIsToBeRequested = !isToBeRequested(consent)

  const thereIsAConsentThatIsToBeRequestedButItSitsInTheCookies =
    getConsentCookie(consent.id, accountId) && !consentCookieIsExpired(consent.id, accountId)

  return (
    Boolean(thereIsNoConsentThatIsToBeRequested) || Boolean(thereIsAConsentThatIsToBeRequestedButItSitsInTheCookies)
  )
}
